import React from 'react';
import i18n from 'i18n';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import { GetAllUsersFields as UsersFields } from 'modules/users/interfaces';
import styles from './styles';

interface UserCardProps {
  user: UsersFields;
}

const UserCard = ({ user }: UserCardProps) => {
  const classes = makeStyles(styles)();

  return (
    <Grid container className={classes.card}>
      <Grid container xs={4} className={classes.containerTitle}>
        <PersonIcon className={classes.personIcon} />
        <Typography className={classes.cardName}>
          {user?.first_name} {user?.last_name}
        </Typography>
      </Grid>
      <Grid className={classes.responsiveGrid}>
        <Grid container xs={6}>
          <Grid container xs={12} className={classes.cardInfos}>
            <Typography className={classes.cardTitles}>
              {i18n.t('PARTNER_KEY')}
              {': '}
            </Typography>
            <Typography className={classes.cardValues}>
              {user?.partner?.partner_name}
            </Typography>
          </Grid>
          <Grid container xs={12} className={classes.cardInfos}>
            <Typography className={classes.cardTitles}>
              {i18n.t('ENVIRONMENT_KEY')}
              {': '}
            </Typography>
            <Typography className={classes.cardValues}>
              {user?.environment?.environment_name}
            </Typography>
          </Grid>
        </Grid>
        <Grid container xs={6}>
          <Grid container xs={12} className={classes.cardInfos}>
            <Typography className={classes.cardTitles}>
              {i18n.t('CLIENT_KEY')}
              {': '}
            </Typography>
            <Typography className={classes.cardValues}>
              {user?.client?.client_name}
            </Typography>
          </Grid>
          <Grid container xs={12} className={classes.cardInfos}>
            <Typography className={classes.cardTitles}>
              {i18n.t('EMAIL_KEY')}
              {': '}
            </Typography>
            <Typography className={classes.cardValues}>
              {user?.email}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserCard;
